(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cobalto-cro"] && !Shopify.designMode) return;
  try {
    class CobaltoStickyBar extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (!this.isConnected) return;
          const form = document.getElementById(this.getAttribute('form'));
          const footer = document.querySelector('.shopify-section--footer');
          const visible = form && form.getBoundingClientRect().bottom < 0 && (!footer || footer.getBoundingClientRect().top > innerHeight);
          this.classList.toggle('is-visible',Boolean(visible));
        });
      };
      window.addEventListener('scroll',schedule,{passive:true,signal:this.controller.signal});
      window.addEventListener('resize',schedule,{signal:this.controller.signal});
      schedule();
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  }
  class CobaltoCartRecommendations extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
      },{rootMargin:'100px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    async load() {
      if (!this.dataset.productId || this.loaded) return;
      this.loaded = true;
      const url = new URL(this.dataset.url,location.origin);
      url.searchParams.set('product_id',this.dataset.productId);
      url.searchParams.set('section_id','cobalto-cart-recommendations');
      url.searchParams.set('limit','10');
      url.searchParams.set('intent','related');
      try {
        const response = await fetch(url,{signal:this.controller.signal,priority:'low'});
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
        if (!this.isConnected) return;
        const inCart = new Set((this.dataset.cartIds || '').split(','));
        const cards = [...parsed.querySelectorAll('[data-cobalto-recommended-product]')].filter(card => !inCart.has(card.dataset.cobaltoRecommendedProduct)).slice(0,1);
        if (!cards.length) return;
        const heading = document.createElement('div');
        heading.className = 'cobalto-recommendations-header';
        const title = document.createElement('p');
        title.className = 'h6';
        title.textContent = this.dataset.heading;
        heading.append(title);
        this.append(heading);
        cards.forEach(card => this.append(document.importNode(card,true)));
      } catch(error) { if (error.name !== 'AbortError') this.replaceChildren(); }
    }
  }
  class CobaltoDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.fallbackText ??= this.querySelector('p')?.textContent || '';
      this.render();
      const timer = setInterval(() => this.render(),60000);
      this.controller.signal.addEventListener('abort',() => clearInterval(timer));
    }
    disconnectedCallback() { this.controller?.abort(); }
    madridNow() {
      const parts = new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Madrid',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hour12:false}).formatToParts(new Date());
      const get = type => Number(parts.find(part => part.type === type)?.value);
      return {y:get('year'),m:get('month'),d:get('day'),h:get('hour') % 24};
    }
    isBusinessDay(date) {
      const day = date.getUTCDay();
      if (day === 0 || day === 6) return false;
      return !this.holidays.has(date.toISOString().slice(0,10));
    }
    addBusinessDays(date,count) {
      const result = new Date(date);
      while (count > 0) { result.setUTCDate(result.getUTCDate() + 1); if (this.isBusinessDay(result)) count -= 1; }
      return result;
    }
    label(date,withMonth) {
      const weekday = new Intl.DateTimeFormat('es-ES',{timeZone:'UTC',weekday:'long'}).format(date);
      const month = withMonth ? ' de ' + new Intl.DateTimeFormat('es-ES',{timeZone:'UTC',month:'long'}).format(date) : '';
      return `${weekday} ${date.getUTCDate()}${month}`;
    }
    render() {
      try {
        this.holidays = new Set((this.dataset.holidays || '').split(',').map(item => item.trim()).filter(Boolean));
        const cutoff = Number(this.dataset.cutoff || 15);
        // Ajuste de tema «Días extra de entrega» (campañas): ensancha el rango sin cambiar el texto (Astra R5.A).
        const extraDays = Math.max(0, Number(this.dataset.extraDays || 0));
        const minDays = Number(this.dataset.minDays || 1);
        const maxDays = Number(this.dataset.maxDays || 3) + extraDays;
        const now = this.madridNow();
        let dispatch = new Date(Date.UTC(now.y,now.m - 1,now.d,12));
        const beforeCutoff = this.isBusinessDay(dispatch) && now.h < cutoff;
        if (!beforeCutoff) dispatch = this.addBusinessDays(dispatch,1);
        const from = this.addBusinessDays(dispatch,minDays);
        const to = this.addBusinessDays(dispatch,maxDays);
        // Codex H6: fuera del periodo con festivos cargados (data-calendar-*) se vuelve al texto de Liquid en vez de prometer fechas sin calendario.
        const today = new Date(Date.UTC(now.y,now.m - 1,now.d)).toISOString().slice(0,10);
        if (!this.dataset.calendarStart || !this.dataset.calendarEnd || today < this.dataset.calendarStart || to.toISOString().slice(0,10) > this.dataset.calendarEnd) {
          const fallback = this.querySelector('p');
          if (fallback) fallback.textContent = this.fallbackText;
          return;
        }
        // Texto (Astra, 12-09): sin imperativo de urgencia; el mes solo cuando el tramo cruza de mes.
        const sameMonth = from.getUTCMonth() === to.getUTCMonth();
        const range = `entre el ${this.label(from,!sameMonth)} y el ${this.label(to,!sameMonth)}`;
        const paragraph = this.querySelector('p') || this.appendChild(document.createElement('p'));
        // «debería llegarte» señala estimación sin más palabras (Astra R5.A); la nota opcional va dentro del paréntesis.
        const note = (this.dataset.note || '').trim();
        paragraph.textContent = `Si lo pides ahora, debería llegarte ${range}${note ? ' · ' + note : ''}.`;
      } catch (error) { /* se conserva el texto renderizado por Liquid */ }
    }
  }
  // Pie: <details> de las listas de enlaces abiertos en escritorio, cerrados en móvil (sin JS: details nativo)
  const cobaltoFooterMedia = matchMedia('(min-width:700px)');
  const cobaltoFooterSync = (root = document, force = false) => {
    root.querySelectorAll('details.cobalto-footer-links').forEach(details => {
      if (!force && details.hasAttribute('data-enhanced')) return;
      if (!cobaltoFooterMedia.matches && details.contains(document.activeElement)) details.querySelector('summary')?.focus({preventScroll:true});
      details.open = cobaltoFooterMedia.matches;
      details.dataset.enhanced = '';
    });
  };
  cobaltoFooterMedia.addEventListener('change',() => cobaltoFooterSync(document,true));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => cobaltoFooterSync(),{once:true}); else cobaltoFooterSync();
  document.addEventListener('shopify:section:load',event => cobaltoFooterSync(event.target));
  const cobaltoDisclosureState = new Map();
  class CobaltoOptionDisclosure extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const key = this.dataset.key || '';
      const desktop = matchMedia('(min-width:700px)');
      const apply = () => { this.details.open = desktop.matches || cobaltoDisclosureState.get(key) === 'open'; };
      apply();
      this.dataset.enhanced = '';
      desktop.addEventListener('change',apply,{signal});
      this.details.addEventListener('toggle',() => { if (!desktop.matches) cobaltoDisclosureState.set(key,this.details.open ? 'open' : 'closed'); },{signal});
      this.addEventListener('pointerdown',event => { this.pointerAt = event.target.closest('label,a') ? Date.now() : 0; },{signal,passive:true});
      this.addEventListener('change',() => {
        if (desktop.matches || Date.now() - (this.pointerAt || 0) > 800) return;
        cobaltoDisclosureState.set(key,'closed');
        cobaltoDisclosureState.set(key + ':focus',true);
      },{signal});
      if (cobaltoDisclosureState.get(key + ':focus')) {
        cobaltoDisclosureState.delete(key + ':focus');
        requestAnimationFrame(() => { if (this.isConnected) this.details.querySelector('summary')?.focus({preventScroll:true}); });
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  const cobaltoSetVariantState = (form, state) => {
    form.dataset.cobaltoVariantState = state;
    const busy = state === 'pending';
    const buttons = [
      ...form.querySelectorAll('[type="submit"], button[name="add"]'),
      ...document.querySelectorAll(`cobalto-sticky-bar[form="${CSS.escape(form.getAttribute('id') || '')}"] button, button[form="${CSS.escape(form.getAttribute('id') || '')}"]`)
    ];
    buttons.forEach(btn => {
      if (!(btn instanceof HTMLElement)) return;
      if (state !== 'ready') {
        if (!btn.hasAttribute('data-cobalto-was-disabled')) btn.dataset.cobaltoWasDisabled = btn.disabled ? '1' : '0';
        btn.setAttribute('aria-busy','true');
        btn.disabled = true;
      } else if (btn.dataset.cobaltoWasDisabled != null) {
        btn.removeAttribute('aria-busy');
        btn.disabled = btn.dataset.cobaltoWasDisabled === '1';
        delete btn.dataset.cobaltoWasDisabled;
      }
    });
    form.querySelectorAll('.shopify-payment-button').forEach(button => {
      button.toggleAttribute('inert', state !== 'ready');
      button.setAttribute('aria-hidden', state !== 'ready' ? 'true' : 'false');
    });
    const status = form.querySelector('[data-cobalto-variant-status]');
    if (status) {
      status.hidden = state === 'ready';
      status.textContent = state === 'error' ? status.dataset.errorMessage : status.dataset.pendingMessage;
    }
    const retry = form.querySelector('[data-cobalto-variant-retry]');
    if (retry) retry.hidden = state !== 'error';
  };
  const cobaltoSyncVariantId = (form, variant) => {
    const variantId = form?.querySelector('input[name="id"]');
    if (!(variantId instanceof HTMLInputElement) || !variant?.id) return false;
    variantId.disabled = false;
    variantId.value = String(variant.id);
    variantId.setAttribute('value', String(variant.id));
    return true;
  };
  const cobaltoVariantForForm = form => {
    const picker = document.querySelector(`variant-picker[form-id="${CSS.escape(form?.getAttribute('id') || '')}"]`);
    const variantJson = picker?.querySelector('script[data-variant]')?.textContent;
    if (!variantJson) return null;
    try { return JSON.parse(variantJson); } catch (_) { return null; }
  };
  const cobaltoSyncInitialVariantIds = () => {
    requestAnimationFrame(() => {
      document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        cobaltoSyncVariantId(form, cobaltoVariantForForm(form));
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cobaltoSyncInitialVariantIds, {once:true});
  } else {
    cobaltoSyncInitialVariantIds();
  }
  document.addEventListener('change',event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('input[data-option-position]')) return;
    const form = input.form;
    if (!form) return;
    cobaltoSetVariantState(form, 'pending');
  },true);
  document.addEventListener('variant:change',event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const requestId = event.detail?.cobaltoVariantRequest;
    if (!requestId || form.dataset.cobaltoVariantRequest !== requestId) return;
    cobaltoSetVariantState(form, 'pending');
    requestAnimationFrame(() => {
      if (!form.isConnected || form.dataset.cobaltoVariantRequest !== requestId) return;
      if (!cobaltoSyncVariantId(form, event.detail?.variant || cobaltoVariantForForm(form))) {
        cobaltoSetVariantState(form, 'error');
        return;
      }
      cobaltoSetVariantState(form, 'ready');
    });
  },true);
  document.addEventListener('variant:error',event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const requestId = event.detail?.cobaltoVariantRequest;
    if (!requestId || form.dataset.cobaltoVariantRequest !== requestId) return;
    cobaltoSetVariantState(form, 'error');
  },true);
  document.addEventListener('click',event => {
    const retry = event.target.closest('[data-cobalto-variant-retry]');
    if (!retry) return;
    const form = retry.closest('form');
    const input = form?.elements && Array.from(form.elements).find(element => element.matches?.('input[data-option-position]:checked'));
    if (input) input.dispatchEvent(new Event('change', {bubbles:true}));
  },true);
  document.addEventListener('submit',event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    const quantity = form.elements.namedItem('quantity');
    const variantId = form.querySelector('input[name="id"]');
    if (quantity && quantity instanceof HTMLInputElement && !quantity.offsetParent) quantity.value = '1';
    if (variantId instanceof HTMLInputElement && !variantId.value) cobaltoSyncVariantId(form, cobaltoVariantForForm(form));
    if ((form.dataset.cobaltoVariantState === 'ready' || !form.dataset.cobaltoVariantState) && variantId instanceof HTMLInputElement && variantId.value) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!form.dataset.cobaltoVariantState) cobaltoSetVariantState(form, 'error');
  },true);
  if (!customElements.get('cobalto-delivery-estimate')) customElements.define('cobalto-delivery-estimate',CobaltoDeliveryEstimate);
  if (!customElements.get('cobalto-option-disclosure')) customElements.define('cobalto-option-disclosure',CobaltoOptionDisclosure);
  if (!customElements.get('cobalto-sticky-bar')) customElements.define('cobalto-sticky-bar',CobaltoStickyBar);
  if (!customElements.get('cobalto-cart-recommendations')) customElements.define('cobalto-cart-recommendations',CobaltoCartRecommendations);
  } catch(e) { console.error(e); }
})();

})();
